import React, { useState } from "react";

import {
  TRIGGERS,
  CONDITIONS,
  ACTIONS,
  TRIGGER_GROUPS,
  STEP_GROUPS,
} from "../catalog";
import { keyActivate } from "../useOutsideClick";

const SearchIcon = (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
    <circle cx="11" cy="11" r="7" /><line x1="21" y1="21" x2="16.65" y2="16.65" />
  </svg>
);

export default function StepPicker({ mode, onPick, inline = false }) {
  const [q, setQ] = useState("");
  const defs = mode === "trigger" ? TRIGGERS : [...CONDITIONS, ...ACTIONS];
  const groups = mode === "trigger" ? TRIGGER_GROUPS : STEP_GROUPS;
  const needle = q.trim().toLowerCase();
  const match = (d) =>
    !needle || d.label.toLowerCase().includes(needle) || d.blurb.toLowerCase().includes(needle);
  const visible = defs.filter(match);

  return (
    <div className={`gmba-dd${inline ? " gmba-dd-inline" : ""}`} onClick={(e) => e.stopPropagation()}>
      <div className="gmba-ddsearch">
        {SearchIcon}
        <input
          ref={(el) => el && el.focus()}
          placeholder={mode === "trigger" ? "Search triggers…" : "Search steps…"}
          value={q}
          onChange={(e) => setQ(e.target.value)}
        />
      </div>
      <div className="gmba-ddscroll">
        {groups.map((group) => {
          const items = visible.filter((d) => d.group === group);
          if (!items.length) return null;
          const note = items.find((d) => d.groupNote)?.groupNote;
          return (
            <React.Fragment key={group}>
              <div className="gmba-grp">{group}</div>
              {note && !needle && <div className="gmba-grpnote">{note}</div>}
              {items.map((d) => (
                <div key={d.id} className="gmba-opt" onClick={() => onPick(d)} {...keyActivate(() => onPick(d))}>
                  <span className="gmba-oic">{d.icon}</span>
                  <span>
                    <div className="gmba-ol">{d.label}</div>
                    <div className="gmba-od">{d.blurb}</div>
                  </span>
                </div>
              ))}
            </React.Fragment>
          );
        })}
        {!visible.length && <div className="gmba-noresults">Nothing matches “{q}” yet.</div>}
      </div>
    </div>
  );
}
